import React from "react";
import { FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-light">
      <h1 className="display-1 text-danger">404</h1>
      <h4 className="mb-3">Page Not Found</h4>
      <p className="mb-4 text-secondary">
        Oops! The page you are looking for does not exist.
      </p>
      <button
        className="btn btn-primary btn-sm px-4 py-2"
        onClick={() => navigate("/")}
      >
        <FaHome className="me-1" />
        Go Home
      </button>
    </div>
  );
};

export default NotFound;
